function esConsecutivo(dia1, dia2) {
    const dias = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"];
    return dias.indexOf(dia1) + 1 === dias.indexOf(dia2);
}

function agruparHorarios(horarios) {
    let grupos = [];
    let grupoActual = null;

    horarios.forEach((horario, index) => {
        if (index === 0 || !esConsecutivo(horarios[index - 1].dia, horario.dia) ||
            horarios[index - 1].inicio !== horario.inicio || horarios[index - 1].fin !== horario.fin) {
            if (grupoActual) {
                grupos.push(grupoActual);
            }
            grupoActual = { dias: [horario.dia], inicio: horario.inicio, fin: horario.fin };
        } else {
            grupoActual.dias.push(horario.dia);
        }
    });

    if (grupoActual) {
        grupos.push(grupoActual);
    }

    return grupos;
}

function formatearHorarios(grupos) {
    return grupos.map(grupo => {
        const rangoDias = grupo.dias.length > 1 ? `${grupo.dias[0]} - ${grupo.dias[grupo.dias.length - 1]}` : grupo.dias[0];
        return `${rangoDias}: ${grupo.inicio.substring(0,5)}h - ${grupo.fin.substring(0,5)}h`;
    });
}

$.ajax({
    url: 'https://api.ohmycut.com/nuevopanel/omc/api/salon/todos',
    type: 'POST',
    dataType: 'json',
    success: function(data) {
        const ciudades = []
        const total_services = []

        const salones = data.datos
        salones.filter(item => item.foto).forEach(item => {

          const grupos = agruparHorarios(item.horario);
          const horariosFormateados = formatearHorarios(grupos).filter(item=>!item.includes('Domingo: 00:00h'));

            const services = []
            if (item.beauty == '1') {
                services.push('BEAUTY')
            }
          if (item.hair == '1') {
                services.push('HAIR')
            }
            if (item.nails == '1') {
                services.push('NAILS')
            }
            if (item.laser == '1') {
                services.push('LÁSER')
            }
            if (item.pedicura == '1') {
                services.push('PEDICURA')
            }
            
            if (!ciudades.includes(item.ciudad)) {
                ciudades.push(item.ciudad)
            }
            if (!total_services.includes(services.join(', '))) {
                total_services.push(services.join(', '))
            }

            $('#salones_list').append(`
              <div class="col-12 col-md-3" services="${services.join(', ')}" city="${item.ciudad}" province="${item.provincia}">
                <div class="salon-item"> 
                  <img src="${item.foto ?? ''}" alt="" width="100%">
                  <div class="px-4 py-2" style="font-size: .9em;">
                  <p><span class="salon-name">${item.nombre}</span> ${item.descripcion}</p>
                  <ul>
                       <li style="color: rgb(16, 156, 4)">Abierto</li>
                      <li>${item.direccion ?? ''}, ${item.ciudad ?? ''}</li>
                       </ul>
                       <hr style="margin:0">
                       <ul>
                       <li>Teléfono: <a href="tel:${item.telefono}" style="text-decoration:underline">${item.telefono}</a></li>
                       ${horariosFormateados.map(item=>{
                         return (`<li>${item.includes('Sabado') ? item.replace('Sabado','Sábado') : item}</li>`)
                       }).join('')}
                       <li>Servicios: <strong>${services.join(', ')}</strong></li>
                  </ul>
                  ${item.aceptaCitas == 1 ? '<a href="' + item.urlCitas + '" class="button button--primary" style="margin-bottom:1em;display:block;text-align:center; width: fit-content;" target="_blank">Pedir cita</a>' : ''}
                  </div>
              </div>
            </div>
            `)
        })


  

        ciudades.filter(item => item.length > 1).sort().forEach(item => {
            $('.city-filter').append(`
	<option value="${item}">${item}</option>
`)
        })
        total_services.filter(item => item.length > 1).forEach(item => {
            $('.room-filter-drop').append(`
 <label><input type="checkbox" name="services" class="service-check" value="${item}">${item}</label>
`)
        })
        let servicesCheckeds = []
        $('.service-check').click(function() {
            const service = $(this).val()
            if ($(this).is(':checked')) {
                if (!servicesCheckeds.includes(service)) {
                    servicesCheckeds.push(service)
                }
            } else {
                servicesCheckeds = servicesCheckeds.filter(s => s != service)
            }

            if (servicesCheckeds.length == 0) {
                $('.col-md-3').removeClass('d-none-services')
            } else {
                $('.col-md-3').each(function() {
                    const serviceCol = $(this).attr('services')
                    if (servicesCheckeds.some(s=>s == serviceCol)) {
                        $(this).removeClass('d-none-services')
                    } else {
                        $(this).addClass('d-none-services')
                    }
                })
            }
        })

    },
    error: function(jqXHR, textStatus, errorThrown) {
        // Aquí manejas los errores de la petición
        console.error('Error en la petición:', errorThrown);
    }
});


$('.city-filter').change(function() {
    const value = $(this).val()
     if(value == '*'){
      $('.col-md-3').removeClass('d-none-city')
    }else{
      $('.col-md-3').each(function() {
          if ($(this).attr('city') == value) {
              $(this).removeClass('d-none-city')
          } else {
              $(this).addClass('d-none-city')
          }
      })
    }
})

let openServices = false;
$('.form-select.room-filter option').click(function() {
    $('.room-filter-drop').css('display', 'flex')
    setTimeout(() => {
        openServices = true
    }, 1000)
})
$(document).click(function(event) {
    if (!$(event.target).closest('.room-filter-drop').length && openServices) {
        $('.room-filter-drop').css('display', 'none');
        openServices = false
    }
});